// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2S--f","content":"styles_content__3ZPDM","row":"styles_row__1QrQb","footer":"styles_footer__V4rTB","phraseLength":"styles_phraseLength__jvAeR"};